import React, { FC, useState } from "react";
import { InputNumber, InputSelect, InputText } from "../../../../components/input";
import { IInputArrayFormProps, IInputArrayDataStructureItem } from "../../../../components/input/arrayData";
import { CreateNotification } from "../../../../components/notifier";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";
import { getDDMMYYYFormat, getDay, getDiffDay, getHHmmFormat, getLocalDate } from "../../../../helper/dateTimeHelper";
import parse from "date-fns/parse";
import { InputDateTimeAntd } from "../../../../components/input/date-time-antd";

export const VehicleContentStructure: IInputArrayDataStructureItem[] = [
  // {
  //   name: "FullName",
  //   label: "Họ và tên",
  //   isVisibleOnList: true,

  // },
  // {
  //   name: "RequestingUnit",
  //   label: "Đơn vị đề nghị",
  //   isVisibleOnList: true,

  // },
  // {
  //   name: "PhoneNumber",
  //   label: "Số điện thoại",
  //   isVisibleOnList: true,

  // },
  {
    name: "StartDate",
    label: "Thời gian bắt đầu",
    isVisibleOnList: true,
  },
  {
    name: "EndDate",
    label: "Thời gian kết thúc",
    isVisibleOnList: true,
  },
  {
    name: "TripItineraty",
    label: "Hành trình",
    isVisibleOnList: true,
  },
  {
    name: "TypeVehicle",
    label: "Loại xe",
    isVisibleOnList: true,
  },
  {
    name: "Amount",
    label: "Số lượng",
    isVisibleOnList: true,
  },
  // {
  //   name: "Reason",
  //   label: "Lý do sử dụng xe công vụ",
  //   isVisibleOnList: true,
  // },
];

export const VehicleContentForm: FC<IInputArrayFormProps> = (props) => {
  const TypeVehicleSelections = [
    "Xe 7 chỗ - Có lái xe",
    "Xe 7 chỗ - Không lái xe",
    "Xe 16 chỗ - Có lái xe",
    "Xe 16 chỗ - Không lái xe",
  ];
  const [typeVehicleSelected, setTypeVehicleSelected] = useState(null as any);

  const { childFormData } = props;
  const today = new Date();
  const StartDate = ObjectUtils.getIn(childFormData, "StartDate", undefined);
  const EndDate = ObjectUtils.getIn(childFormData, "EndDate", undefined);
  const [startDate, setStartDate] = useState(StartDate ? parse(StartDate, "d/M/yyyy HH:mm", new Date()) : today);
  const [endDate, setEndDate] = useState(EndDate ? parse(EndDate, "d/M/yyyy HH:mm", new Date()) : today);

  // const employees = useSelector((state: any) => state.employee.employees);
  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.TypeVehicle = typeVehicleSelected ? typeVehicleSelected : values.TypeVehicle;
      values.StartDate = startDate ? getDDMMYYYFormat(startDate) + " " + getHHmmFormat(startDate) : values.StartDate;
      values.EndDate = endDate ? getDDMMYYYFormat(endDate) + " " + getHHmmFormat(endDate) : values.EndDate;
      if (
        !values.TypeVehicle ||
        !values.Amount ||
        !values.StartDate ||
        !values.EndDate ||
        // !values.Reason ||
        !values.TripItineraty
      )
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
      else props.onSubmit(values);
    },
  });
  const onTypeVehicleChange = (e: any) => {
    setTypeVehicleSelected(e.value);
  };

  const onStartDateChange = (date: any) => {
    const newDate = new Date(date);
    setStartDate(newDate);
    setEndDate(newDate);
    const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(startDate)));
    if (days < 0) {
      setStartDate(newDate);
    }
  };

  const onEndDateChange = (date: any) => {
    const newDate = new Date(date);
    setEndDate(newDate);
    const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(endDate)));
    if (days < 0) {
      setEndDate(newDate);
    }
  };
  //   useEffect(() => {
  //     if (employees) {
  //       if (childFormData && childFormData.staffCode) {
  //         setEmployeesSelected(employees.find((o: any) => o.eEmployeeId === childFormData.staffCode).eMail);
  //       } else {
  //         setEmployeesSelected(employees[0].eMail);
  //         setEmployeesCode(employees[0].eEmployeeId);
  //       }
  //     }
  //   }, [employees])

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>
      {/* <InputWraper
        inputProps={getInputProps("FullName")}
        renderInput={(s) => <InputText {...s} />}
      />
      <InputWraper
        inputProps={getInputProps("RequestingUnit")}
        renderInput={(s) => <InputText {...s}  />}
      />
      <InputWraper
        inputProps={getInputProps("PhoneNumber")}
        renderInput={(s) => <InputNumber {...s} />}
      /> */}
      <InputWraper
        inputProps={getInputProps("TypeVehicle")}
        renderInput={(s) => (
          <InputSelect
            {...s}
            options={TypeVehicleSelections.map((e: any) => ({
              label: e,
              value: e,
            }))}
            onChange={onTypeVehicleChange}
            value={typeVehicleSelected ? typeVehicleSelected : s.value}
            placeholder="* Vui lòng chọn loại xe"
          />
        )}
        isRequired
      />
      <InputWraper inputProps={getInputProps("Amount")} renderInput={(s) => <InputNumber {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("TripItineraty")} renderInput={(s) => <InputText {...s} />} isRequired />
      <InputWraper
        inputProps={getInputProps("StartDate")}
        isRequired
        renderInput={(s) => (
          <>
            <InputDateTimeAntd
              {...s}
              value={startDate}
              minDate={today}
              isShowTime={true}
              onChange={onStartDateChange}
            />
          </>
        )}
      />
      <InputWraper
        inputProps={getInputProps("EndDate")}
        isRequired
        renderInput={(s) => (
          <>
            <InputDateTimeAntd
              {...s}
              value={endDate}
              minDate={startDate && startDate}
              isShowTime={true}
              onChange={onEndDateChange}
            />
          </>
        )}
      />
      {/* <InputWraper
        inputProps={getInputProps("Reason")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      /> */}
      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
